import "./style.css";
import { jsxs as s, jsx as t, Fragment as _ } from "react/jsx-runtime";
import { c as b } from "../../__shared__/index.js";
const i = "_container_q05tb_13", d = "_label_q05tb_21", u = "_bars_q05tb_30", f = "_bar_q05tb_30", m = "_notFilled_q05tb_44", p = "_readout_q05tb_48", e = {
  container: i,
  label: d,
  bars: u,
  bar: f,
  notFilled: m,
  readout: p
};
function j({
  maximum: r,
  intensity: a,
  label: l = "",
  showLabel: n = !1
}) {
  if (a <= 0 || a > r || !l)
    return null;
  const c = Array.from(Array(r).keys());
  return /* @__PURE__ */ s(
    "div",
    {
      className: e.container,
      "aria-label": l,
      role: "meter",
      "aria-valuenow": a,
      "aria-valuemin": 0,
      "aria-valuemax": r,
      children: [
        n && /* @__PURE__ */ t("span", { className: e.label, children: l }),
        /* @__PURE__ */ t("div", { className: e.bars, children: c.map((v, o) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ t(q, { position: o + 1, intensity: a }, o)
        )) })
      ]
    }
  );
}
function q({ intensity: r, position: a, ...l }) {
  const n = r >= a;
  return /* @__PURE__ */ s(_, { children: [
    /* @__PURE__ */ t("div", { className: b(e.bar, !n && e.notFilled), ...l }),
    a === r && /* @__PURE__ */ t("span", { className: e.readout, children: r })
  ] });
}
export {
  j as default
};
//# sourceMappingURL=IntensityMeter.js.map
